import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["tab", "contents"];

  connect() {}

  switch(event) {
    const tabValue = parseInt(event.currentTarget.dataset.tabValue);

    // Update active tab styling
    this.tabTargets.forEach((tab) => {
      tab.classList.toggle(
        "tab-active",
        parseInt(tab.dataset.tabValue) === tabValue,
      );
    });

    // Show/hide content
    this.contentsTarget
      .querySelectorAll("[data-tab-value]")
      .forEach((content) => {
        content.classList.toggle(
          "hidden",
          parseInt(content.dataset.tabValue) !== tabValue,
        );
      });

    // Update URL without page reload
    const url = new URL(window.location);
    url.searchParams.set("tab", tabValue);
    history.pushState({}, "", url);
    Turbo.navigator.history.push(url);
  }
}
